import { Injectable } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';

@Injectable({ providedIn: 'root' })
export class ErrorService {
  extractMessage(error: unknown): string {
    if (!error) return 'Error desconocido.';

    if (error instanceof HttpErrorResponse) {
      const backendMsg = (error.error && (error.error.message || error.error.error)) || '';
      const statusText = error.statusText || '';
      if (error.status === 0) return 'No se pudo conectar con el servidor. Verifica tu conexión.';
      return backendMsg || error.message || statusText || `Error HTTP ${error.status}`;
    }

    if (error instanceof Error) {
      return error.message || 'Error de aplicación.';
    }

    try {
      return JSON.stringify(error);
    } catch {
      return String(error);
    }
  }
}
